/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('popup.document', ['popup', 'data.document']);
